import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getClientHierarchyThunk = createAsyncThunk(
    `ClientHierarchySlicer/getClientHierarchyThunk`,
    async (term, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const url = term
            ? `ParticipantHierarchy/descendants/search?term=${term}`
            : "ParticipantHierarchy/descendants/search"

        const { data } = await conciergeApiClient.get(url, { headers });

        return data;
    }
);

const initialState = {
    dataClientHierarchy: [],
    loadingClientHierarchy: false,
    errorClientHierarchy: false,
};

const ClientHierarchySlicer = createSlice({
    name: 'clientHierarchy',
    initialState,
    reducers: {
        resetDataSpot: (state) => {
            state.dataClientHierarchy = [];
            state.loadingClientHierarchy = false;
            state.errorClientHierarchy = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getClientHierarchyThunk.pending, (state) => {
            state.dataClientHierarchy = [];
            state.loadingClientHierarchy = true;
            state.errorClientHierarchy = false;
        });
        builder.addCase(getClientHierarchyThunk.fulfilled, (state, action) => {
            state.dataClientHierarchy = action.payload;
            state.loadingClientHierarchy = false;
            state.errorClientHierarchy = false;
        });
        builder.addCase(getClientHierarchyThunk.rejected, (state) => {
            state.dataClientHierarchy = [];
            state.loadingClientHierarchy = false;
            state.errorClientHierarchy = true;
        });
    },
});

export const { resetDataSpot } = ClientHierarchySlicer.actions;
export default ClientHierarchySlicer.reducer;